import { mockIncidents } from '../data/mockData';

const STORAGE_KEY = 'safeguardpro_incidents_v1';

const normalizeIncident = (incident) => ({
  id: incident.id,
  type: incident.type || 'Other',
  date: incident.date || new Date().toISOString(),
  reportedBy: incident.reportedBy || incident.staff || '',
  description: incident.description || '',
  severity: incident.severity || 'medium',
  status: incident.status || 'open',
  assignedKeyWorker: incident.assignedKeyWorker || '',
  followUpRequired: Boolean(incident.followUpRequired || incident.followUpDate),
  followUpDate: incident.followUpDate || null,
  followUpPrompt: incident.followUpPrompt || '',
  participants: incident.participants || [],
  inventoryItemIds: incident.inventoryItemIds || [],
  documents: incident.documents || [],
  createdBy: incident.createdBy || incident.reportedBy || 'System',
  createdAt: incident.createdAt || new Date().toISOString(),
  updatedAt: incident.updatedAt || incident.createdAt || new Date().toISOString()
});

export default class IncidentRepository {
  constructor() {
    this.cache = null;
  }

  load() {
    if (this.cache) return this.cache;
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (stored) {
      this.cache = JSON.parse(stored).map(normalizeIncident);
    } else {
      this.cache = mockIncidents.map(normalizeIncident);
      this.persist();
    }
    return this.cache;
  }

  persist() {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(this.cache));
  }

  getAll() {
    return [...this.load()];
  }

  getById(id) {
    return this.load().find((incident) => incident.id === id) || null;
  }

  create(incident) {
    this.cache = this.load();
    this.cache = [incident, ...this.cache];
    this.persist();
    return incident;
  }

  update(id, updated) {
    this.cache = this.load();
    this.cache = this.cache.map((incident) => (incident.id === id ? updated : incident));
    this.persist();
    return updated;
  }
}
